import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { constants, IconError } from 'mage-deps/@klarna/bubble-ui'

TextArea.propTypes = {
  testId: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  errorLabel: PropTypes.string
}

const { Salmiak, Pumice, Ming, Flint, Cardinal, Scarlet, Ballet } = constants.Colors.palette
const { KLARNA_TEXT_REGULAR } = constants.Fonts

const LINE_HEIGHT = 25

export default function TextArea({ testId, value, onChange, onBlur, placeholder, errorLabel }) {
  const [isFocused, setIsFocused] = useState(false)

  return (
    <div
      style={{
        borderRadius: 5,
        borderStyle: 'solid',
        borderWidth: '1px',
        borderColor: toRGB(borderColor(isFocused, errorLabel)),
        textRendering: 'geometricprecision',
        WebkitFontSmoothing: 'antialiased',
        lineHeight: `${LINE_HEIGHT}px`,
        padding: 15,
        backgroundColor: errorLabel ? toRGB(Ballet) : 'transparent'
      }}
    >
      <div
        style={{
          fontFamily: KLARNA_TEXT_REGULAR.fontFamily,
          fontWeight: KLARNA_TEXT_REGULAR.fontWeight,
          position: 'relative'
        }}
      >
        <div
          data-testid={testId}
          style={{
            minHeight: LINE_HEIGHT * 2,
            maxHeight: LINE_HEIGHT * 6,
            overflowX: 'hidden',
            overflowY: 'auto',
            outline: 'none',
            whiteSpace: 'pre-wrap',
            caretColor: toRGB(Ming),
            color: toRGB(Salmiak)
          }}
          value={value}
          onInput={event => onChange(event.target.innerText)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => {
            setIsFocused(false)
            onBlur()
          }}
          contentEditable
        />
        <div
          style={{
            pointerEvents: 'none',
            display: !isFocused && (!value || value.trim() === '') ? 'block' : 'none',
            position: 'absolute',
            top: 0,
            color: errorLabel ? toRGB(Scarlet) : toRGB(Flint)
          }}
        >
          {placeholder}
        </div>
        {errorLabel && (
          <div style={{ color: toRGB(Cardinal), display: 'flex', alignItems: 'center' }}>
            <div style={{ marginRight: 9, display: 'flex', alignItems: 'center' }}>
              <IconError color="red" />
            </div>
            <div>{errorLabel}</div>
          </div>
        )}
      </div>
    </div>
  )
}

function toRGB(color) {
  return `rgba(${color.red}, ${color.green}, ${color.blue}, ${color.alpha})`
}

function borderColor(isFocused, errorLabel) {
  if (isFocused) {
    return Salmiak
  } else if (errorLabel) {
    return Scarlet
  } else {
    return Pumice
  }
}
